// extracted by mini-css-extract-plugin
export default {"lojaWrapper":"styles_lojaWrapper__eQWVU"};